
import React from 'react';
import { Button, Icon } from '@material-ui/core';
import { ClientContext } from '../../ClientContext';

export function ClientAvatarUpload() {
    const clientContext = React.useContext(ClientContext);
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target?.files?.[0];

        if (file)
            clientContext.setClientAvatarFile(file);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (clientContext.clientAvatarFile != null) {
            event.preventDefault();
            clientContext.setClientAvatarFile(null);
        }
    };

    return (
        <label htmlFor="contained-button-file">
            <Button 
                variant="contained" 
                color="primary" 
                component="span"
                size="large"
                onClick={handleClick}
                onChange={handleChange}
                startIcon={clientContext.clientAvatarFile ? <Icon>delete</Icon> : <Icon>upload</Icon>}>
                {clientContext.clientAvatarFile ? 'Limpar' : 'Upload'}
                <input
                    id="contained-button-file"
                    hidden
                    type="file"
                    accept="image/*"
                />
            </Button>
        </label>
    );
}